export enum FileFields {
    fileSize = 'FILESIZE',
    extension = 'SUFFIX',
    fileName = 'EXTFILEDES',
    fileData = 'EXTFILENAME',
    userName = 'USERLOGIN',
    lockUser = 'LUSERLOGIN',
    noSend = 'NOSEND',
    status = 'STATUS',
    fileDate = 'CURDATE',
    dataExchange = 'EI_COND'
}

export enum FileStatus {
    readOnly = 'R'
}
